import { render, staticRenderFns } from "./GoodsPurchaseDeclaration.vue?vue&type=template&id=5389ee64"
import script from "./GoodsPurchaseDeclaration.vue?vue&type=script&lang=js"
export * from "./GoodsPurchaseDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports